import store from '../store';
import {PAGE_LOADED, PAGE_LOADING} from "../store/actions/page";

export const formatDecimal = function (val, cantDecimales) {
    var d = parseFloat(val);
    if (!isNaN(d)) {
        return d.toLocaleString('en', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    } else {
        return '';
    }
};

export const loading = (val) => {
    if (val)
        store.dispatch(PAGE_LOADING);
    else
        store.dispatch(PAGE_LOADED)
};


export const getFileName = (response) => {
    const contentDisposition = response.headers['content-disposition'];
    return contentDisposition.substr(contentDisposition.indexOf('filename=') + 9);
};

export const toSlug = (str) => {
    if (!str)
        return '';
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to = "aaaaeeeeiiiioooouuuunc------";
    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-')// collapse dashes
        .replace(/-*$/, ''); // remove trailing dashes

    return str;
}



// WEBPACK FOOTER //
// ./src/util/util.js